import React, { Component, Fragment } from 'react';
import { Card, Row, Col, } from 'reactstrap';
import "moment/locale/es";
import moment from 'moment';
import Spinner from 'react-bootstrap/Spinner';
import FragmentsQuerysAndProcedures from './FragmentsQuerysAndProcedures';
import ClinicNotesHistoryComplete from '../../../ClinicHistoryComplete/Components/ClinicNotesHistoryComplete';
import FragmentsOldsQuerysAndProcedures from './FragmentsOldsQuerysAndProcedures';
import ClinicSpeechTerapyText from '../../../ClinicHistoryComplete/Components/ClinicSpeechTerapyText';

class ViewClinicHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pacient: {},
            histories: [],
            loading: true,
            age: '',
            date: '',
        }
    }

    componentDidMount() {
        console.log(this.props);
        this.getClinicHistory();
        this.calculateAge(this.props.data.birthday);
    }

    calculateAge = (birthday) => {

        let hoy = new Date();
        let cumpleanos = new Date(birthday);

        let edad = hoy.getFullYear() - cumpleanos.getFullYear();

        let meses = hoy.getMonth() - cumpleanos.getMonth();
        

        if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }        

        let cantMeses = meses;

        if(meses < 0){
            cantMeses = 12 + meses;
        }

        let edadTotal = edad + ' años ' + cantMeses + ' meses';

        let fecha = moment(birthday, "YYYYMMDD").fromNow(true);
        let nacimiento = moment(birthday).format("YYYY-MM-DD");

        this.setState({ age: edadTotal, date: nacimiento });
    }

    createResults = (resultados) => {

        const div = document.createElement('div');
        div.innerHTML = resultados;
        //console.log(div);
        return div;

    }

    getClinicHistory = () => {

        fetch(process.env.REACT_APP_PUBLIC_URL + 'historia-informe/consultar-historia-completa?id_historia=' + this.props.data.id_historia, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        })
            .then(response => {
                return response.json();
            })
            .then(data => {
                console.log("dataHistories",data);
                this.setState({ loading: false, histories: data.historia },() => {
                    console.log("histories",this.state.histories);
                });
            })
            .catch((error) => {
                alert(error);
                console.error('Error:', error);
            });
    }
  
    render() {

        return (

            <Card style={{ height: '600px', overflowY: 'scroll', overflowX: 'hidden' }}>
                <Col>
                    {this.state.loading ?
                        <div className="text-center">
                            <Spinner animation="border" variant="success" />
                        </div> :
                        <div style={{ padding: 5, border: '1px solid #CACDD1', borderRadius: 5 }}>
                            <h4 style={{ marginBottom: 20 }} >Paciente</h4>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Nombre: </b> {this.props.data.nombres} </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b> No. Historia: </b> {this.props.data.num_documento} </h5>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Fecha de Nacimiento: </b> {this.state.date}   </h5>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <h5> <b>  Edad: </b> {this.state.age} </h5>
                                    </Col>
                                </Row>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <h5> <b> Genero: </b>  {this.props.data.sexo} </h5>
                                    </Col>
                                    <Col md={6} sm={12}>

                                    </Col>
                                </Row>
                            </div>
                        </div>
                    }

                    {this.state.histories.map((history, index) => {

                        return (

                            <div key={index} style={{ padding: 5, border: '1px solid #CACDD1', borderRadius: 5 }}>
                                <h4 style={{ marginTop: 5 }} >  <b>No. Admisión </b> {history.id_admision} -
                                    {history.fecha !== null ?
                                        <Fragment>
                                            <b> Fecha admisión </b> {moment(history.fecha).format("LL")}
                                        </Fragment>
                                        : null}
                                </h4>

                                {history.consulta != null ? <FragmentsQuerysAndProcedures data={history.consulta} /> : null}
                                {history.consulta2 != null ? <FragmentsQuerysAndProcedures data={history.consulta2} /> : null}
                                {history.consulta3 != null ? <FragmentsQuerysAndProcedures data={history.consulta3} /> : null}
                                {history.consulta4 != null ? <FragmentsQuerysAndProcedures data={history.consulta4} /> : null}
                                {history.procedimiento != null ? <FragmentsQuerysAndProcedures data={history.procedimiento} /> : null}
                                {history.miofuncional != null ? <FragmentsQuerysAndProcedures data={history.miofuncional} /> : null}
                                {history.completo != null ? <FragmentsOldsQuerysAndProcedures data={history.completo} /> : null}
                                {history.audiometria != null ? <ClinicSpeechTerapyText audiometria={history.audiometria} /> : null}
                                {typeof history.notas_clinicas !== 'undefined' ?
                                    <ClinicNotesHistoryComplete notas_clinicas={history.notas_clinicas} /> : null}
                            </div>
                        );
                    })}

                </Col>
            </Card>
        );
    }
}

export default ViewClinicHistory;
